import { render, staticRenderFns } from "./PlacementGrid.vue?vue&type=template&id=0742740f&"
import script from "./PlacementGrid.vue?vue&type=script&lang=js&"
export * from "./PlacementGrid.vue?vue&type=script&lang=js&"
import style0 from "./PlacementGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports